
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _export from '../internals/export.js';
import functionUncurryThis from '../internals/function-uncurry-this.js';
import indexedObject from '../internals/indexed-object.js';
import toIndexedObject$1 from '../internals/to-indexed-object.js';
import arrayMethodIsStrict$1 from '../internals/array-method-is-strict.js';

var $ = _export;
var uncurryThis = functionUncurryThis;
var IndexedObject = indexedObject;
var toIndexedObject = toIndexedObject$1;
var arrayMethodIsStrict = arrayMethodIsStrict$1;

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject !== Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});
//# sourceMappingURL=es.array.join.js.map
